import classNames from 'classnames'
import React, { ReactElement, ReactNode } from 'react'

export function DefinitionList(props: { className?: string; children: ReactNode }): ReactElement {
  return <dl className={classNames(props.className, 'p-0 m-0')}>{props.children}</dl>
}

interface DefinitionItemProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  value?: string | number
  truncate?: boolean
}

export function DefinitionItem({ title, value, truncate = true, ...other }: DefinitionItemProps): ReactElement {
  return (
    <div {...other}>
      <dt className="text-gray-600 p-0 m-0 pb-1 pr-1">{title}</dt>
      <dd className={classNames(truncate && 'truncate m-0 p-0')} style={{ color: 'var(--color-emphasis-high)' }}>
        {value || '—'}
      </dd>
    </div>
  )
}
